import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="10" height="958" viewBox="0 0 10 958" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" {...props}><path d="M8.31 1C.51 204.67-.83 455.95 3.26 956.5M4.51 10.4c3.62 313.22 3.54 621.57-.08 930.63" stroke="#000" strokeWidth="2" strokeLinecap="round" /></svg>);